<template>
    <div>
        <app-section class="l-sections">
            <app-builder
                v-if="page.sections && page.sections.length"
                :sections="page.sections"
                :display-anchors="page.hasAnchors"
            />
        </app-section>
    </div>
</template>

<script>
import AppBuilder from 'layout/AppBuilder'
import AppSection from 'layout/AppSection'

import { SECTION_HANDLES } from 'src/constants'

export default {
    name: 'Vision',
    components: {
        AppBuilder,
        AppSection
    },
    metaInfo() {
        return {
            title: this.page.seo ? this.page.seo.title : null
        }
    },
    props: {
        page: Object,
    },
    data: () => ({
        SECTION_HANDLES
    }),
};

</script>

<style lang="scss">

.p-vision {}

</style>
